import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.13_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.2/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app_components/articles/Article.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app_components/articles/ArticleDir.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/src/app_components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app_components/icon/BackArrow.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/src/app_components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/src/app_components/user/UserContext.tsx");
